import { UserTypesApiResultInterface } from '../model/UserTypesApiResultInterface'
import { UserTypesStoreInterfaceSnapshotOut } from '../state-manager/UserTypesStore'

export const UserTypesApiAdapter = (data: UserTypesApiResultInterface): UserTypesStoreInterfaceSnapshotOut => {
  return {
    id: data.id,
    types: data.types
  }
}
